import * as React from 'react'
import type { LeadStatusSelectorProps } from './typings'

import MenuItem from '@mui/material/MenuItem'

import { useActions } from './useActions'
import { SelectStyled } from '@sales-center/components'
import { ENTITY_TYPES } from '@sales-center/common'
import { ClosedLostReasonsDialog } from '@user/components/ClosedLostReasonsDialog'

export function LeadStatusSelector(props: LeadStatusSelectorProps) {
  const {
    canUpdate,
    isDisqualified,
    salesFunnelStages,
    lead: { id, salesFunnelStageId, salesFunnelId, assigneeId },
  } = props

  const { onChangeLeadStatus } = useActions(props)

  return (
    <>
      <SelectStyled
        select
        disabled={!canUpdate || isDisqualified}
        onChange={onChangeLeadStatus}
        variant="outlined"
        value={
          salesFunnelStages && salesFunnelStages.length > 0
            ? salesFunnelStageId
            : ''
        }
        fullWidth
        label="Lead Status"
        size="small"
        data-test-id={`lead-status-selector-${id}`}
      >
        {salesFunnelStages.map((stage) => (
          <MenuItem
            key={stage.id}
            style={{ fontSize: '14px' }}
            value={stage.id}
          >
            {stage.name}
          </MenuItem>
        ))}
      </SelectStyled>

      <ClosedLostReasonsDialog
        entityId={id}
        salesFunnelId={salesFunnelId}
        assigneeId={assigneeId}
        entityType={ENTITY_TYPES.Lead}
      />
    </>
  )
}
